import { render, staticRenderFns } from "./writtenOffRelation.vue?vue&type=template&id=9746f1fe&scoped=true"
import script from "./writtenOffRelation.vue?vue&type=script&lang=js"
export * from "./writtenOffRelation.vue?vue&type=script&lang=js"
import style0 from "./writtenOffRelation.vue?vue&type=style&index=0&id=9746f1fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9746f1fe",
  null
  
)

export default component.exports